import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { MatDialog } from '@angular/material/dialog';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';
import { CommonService } from '../../../../../shared/services/common.service';

@Component({
  selector: 'app-viewandreplygrievance',
  templateUrl: './viewandreplygrievance.component.html',
  styleUrl: './viewandreplygrievance.component.css'
})
export class ViewandreplygrievanceComponent {
  form: FormGroup;
  msmeDetailsForm: FormGroup;
  GrievanceList: any[] = [];
  grievanceReply: any = {};

  grievanceId = sessionStorage.getItem("GrievanceId");
  statusList: any[] = [];
  sendToIA: boolean = false;


  hideDownload: boolean = true;
  hideFileUpload: boolean = true;
  showDownloadBtn: boolean = false;

  grievanceDocumentFile: File | null = null;
  grievanceDocumentfileErrors: { typeError: boolean; sizeError: boolean } = { typeError: false, sizeError: false };
  maxSizeInMB = 10;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private apiService: ApiService,
    private toastrService: ToastrService, private commonService: CommonService,
    public dialog: MatDialog) {
    this.form = this.fb.group({
      justificationByIA: new FormControl('',[Validators.required]),
      reply: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(500), Validators.pattern(this.commonService.grievanceDescription)]),
      status: new FormControl('', [Validators.required]),
      documents: this.fb.array([]),
      resolvedDocumentName: new FormControl(''),
      resolvedDocumentPath: new FormControl(''),
    });

    this.msmeDetailsForm = this.fb.group({
      msmeGrievanceId: new FormControl(''),
      grievanceName: new FormControl(''),
      subject: new FormControl(''),
      description: new FormControl(''),
      createdDate: new FormControl(''),
      documentName: new FormControl(''),
      documentPath: new FormControl(''),
    });
  }

  get f() {
    return this.form.controls;
  }

  ngOnInit(): void {
    this.msmeDetailsForm.disable();
    this.LoadGrievanceStatus();
    if (this.grievanceId) {
      this.LoadGrievanceReply(this.grievanceId);
      this.LoadDetails(this.grievanceId);
    }

    this.form.get('justificationByIA')?.valueChanges.subscribe((value) => {
      if (value) {
        this.sendToIA = true;
        this.disableOtherControls();
      } else {
        this.sendToIA = false;
        this.enableOtherControls();
      }
    });
  }

  disableOtherControls() {
    Object.keys(this.form.controls).forEach(controlName => {
      if (controlName !== 'justificationByIA') {
        const control = this.form.get(controlName);
        control?.disable();
        control?.clearValidators();  
        control?.updateValueAndValidity();
      }
    }); 
  }
  
  enableOtherControls() {
    this.form.enable();
    this.form.get('reply')?.setValidators([Validators.required, Validators.minLength(3), Validators.maxLength(500), Validators.pattern(this.commonService.grievanceDescription)]);
    this.form.get('status')?.setValidators([Validators.required]);
  }

  LoadDetails(grievanceId: string) {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.GETGRIEVANCEDETAILSBYGRIEVANCEID, { grievanceId }).subscribe(
      (result) => {
        if (result.status) {
          this.GrievanceList = result.data;
          this.msmeDetailsForm.patchValue(this.GrievanceList);
          if (result.data.documentName != null) {
            //enable Download option in html and hide file upload
            this.hideDownload = false;
          } else {
            //Disabled Download option and hide file upload
            this.hideDownload = true;
          }
        } 
      }
    );
  }

  LoadGrievanceStatus() {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.GETGRIEVANCESTATUS).subscribe(
      (result) => {
        if (result.status) {
          this.statusList = result.data;
        }
      }
    );
  }

  onGrievanceFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length) {
      this.grievanceDocumentFile = input.files[0];

      this.grievanceDocumentfileErrors = { typeError: false, sizeError: false };

      const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf', 'application/zip'];
      if (!validTypes.includes(this.grievanceDocumentFile.type)) {
        this.grievanceDocumentfileErrors.typeError = true;
      }

      const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024;
      if (this.grievanceDocumentFile.size > maxSizeInBytes) {
        this.grievanceDocumentfileErrors.sizeError = true;
      }
    }
  }

  onDownload() {
    var filePath = this.msmeDetailsForm.get('documentPath')?.value;
    var fileName = this.msmeDetailsForm.get('documentName')?.value;
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    });
  }

  onDownloadReply() {
    var filePath = this.form.get('resolvedDocumentPath')?.value;
    var fileName = this.form.get('resolvedDocumentName')?.value;
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'ReviewerComment_'+fileName || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    });
  }

  onPressBack() {
    this.router.navigate(['/mssidcGrievanceDashboard']);
  }

  OnReset() {
    this.form.clearValidators();
    this.form.reset();
  }

  onSubmit() {
    if (this.form.valid) {
      if (this.sendToIA) {

        const formData = new FormData();
        formData.append('grievanceId', this.msmeDetailsForm.get('msmeGrievanceId')?.value);
        formData.append('justificationByIA', this.form.get('justificationByIA')?.value);

        this.apiService.postRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.SAVEMSSIDCGRIEVANCEREPLY, formData).subscribe(
          (result) => {
            if (result.status) {
              this.toastrService.success("Request sent to IA successfully.");
              window.location.reload();            
            }
          }
        );
        this.router.navigate(['/mssidcGrievanceDashboard']);
      } else
      {
        const formData = new FormData();
        formData.append('grievanceId', this.msmeDetailsForm.get('msmeGrievanceId')?.value);
        formData.append('reply', this.form.get('reply')?.value);
        formData.append('status', this.form.get('status')?.value);
        formData.append('justificationByIA', this.form.get('justificationByIA')?.value);

        if (this.grievanceDocumentFile) {
          formData.append('grievanceFile', this.grievanceDocumentFile, this.grievanceDocumentFile.name);
        }
        this.apiService.postRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.SAVEMSSIDCGRIEVANCEREPLY, formData).subscribe(
          (result) => {
            if (result.status) {
              this.toastrService.success("Data saved successfully.");
              window.location.reload();
            }
          }
        );
        //this.router.navigate(['/mssidcGrievanceDashboard']);
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  LoadGrievanceReply(grievanceId: string) {
    this.apiService.getRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.GETGRIEVANCEREPLYFORMSSIDC, { grievanceId }).subscribe(
      (result) => {
        if (result.status) {          
          this.grievanceReply = result.data;
          this.form.patchValue(this.grievanceReply, { emitEvent: false });           
          if (this.grievanceReply.statusName != 'Pending') { //IsReplied=true
            if (this.grievanceReply.resolvedDocumentName != null) {
              this.showDownloadBtn = true;
              //show download button
              this.form.disable();
            }
            else {              
              this.hideFileUpload = true;
              //hide  control
              this.form.disable();
            }
          }
          else {
            this.hideFileUpload = false;
            if (this.grievanceReply.justificationByIA) {
              this.form.disable();
              this.hideFileUpload = true;
            }
            //show fileupload
          }    
        }
      }
    );
  }

  openFilePreviewDialog(): void {
    var filePath = this.msmeDetailsForm.get('documentPath')?.value;
    var fileName = this.msmeDetailsForm.get('documentName')?.value;

    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }

  openReviewerFilePreviewDialog(): void {
    var filePath = this.form.get('resolvedDocumentPath')?.value;
    var fileName = this.form.get('resolvedDocumentName')?.value;

    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }
}
